module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade-and-fall"
    }
  }, [_c('section', {
    staticClass: "modal modal--spacious"
  }, [_c('div', {
    staticClass: "modal__container"
  }, [_c('div', {
    staticClass: "modal__body"
  }, [_c('div', {
    staticClass: "modal__header"
  }, [_c('h2', {
    staticClass: "modal__title title--general title--2"
  }, [_vm._v("\n\t\t\t\t\t\tLog in to your dashboard\n\t\t\t\t\t")])]), _vm._v(" "), _c('form', {
    staticClass: "modal__section",
    class: {
      'has-error': _vm.errors.any()
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login()
      }
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "label": "E-mail",
      "data-vv-validate-on": "blur",
      "type": "text",
      "name": "email",
      "error-messages": _vm.errors.has('email') ? 'Enter your email' : [],
      "outlined": ""
    },
    model: {
      value: (_vm.credential.email),
      callback: function($$v) {
        _vm.$set(_vm.credential, "email", $$v)
      },
      expression: "credential.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Password",
      "data-vv-validate-on": "blur",
      "type": "password",
      "name": "password",
      "error-messages": _vm.errors.has('password') ? 'Enter password' : [],
      "outlined": ""
    },
    model: {
      value: (_vm.credential.password),
      callback: function($$v) {
        _vm.$set(_vm.credential, "password", $$v)
      },
      expression: "credential.password"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "large": "",
      "type": "submit",
      "loading": _vm.isLoading,
      "disabled": _vm.isLoading,
      "color": "primary"
    }
  }, [_vm._v("\n\t\t\t\t\t\tLog in\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('apierror')),
      expression: "errors.has('apierror')"
    }],
    staticClass: "input-field__error"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('apierror')) + " ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal__footer modal__footer--spread"
  }, [_c('router-link', {
    staticClass: "link link--white link--clean",
    attrs: {
      "to": {
        path: 'forgot-password',
        query: {
          email: this.credential.email
        }
      }
    }
  }, [_vm._v("\n\t\t\t\t\tForgot your password?\n\t\t\t\t")]), _vm._v(" "), _c('router-link', {
    staticClass: "link link--white link--clean",
    attrs: {
      "to": {
        path: 'registration'
      }
    }
  }, [_vm._v("\n\t\t\t\t\tDon’t have an account? Sign up!\n\t\t\t\t")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1815457b","hasScoped":true}!./app/components/login-modal/template.html
// module id = 347
// module chunks = 0